import { cx, css } from "react-emotion";
import { isMobile } from "components/ReactUtils/mobileDetect.js";
import { observer } from "mobx-react";
import currencyFormatter from "currency-formatter";
import React from "react";

function money(value, { symbol = true } = {}) {
  return currencyFormatter.format(value, {
    thousand: ".",
    symbol: "€",
    precision: 0,
    format: symbol ? "%v %s" : "%v",
  });
}

class InputText extends React.Component {
  state = { focus: false };

  componentDidMount() {
    const { mountWithFocus } = this.props;
    if (mountWithFocus) this.input.focus();
  }

  onFocus = e => {
    const { onFocus } = this.props;
    this.setState({ ...this.state, focus: true });
    onFocus && onFocus(e);
  };

  onBlur = e => {
    const { store, name, validateOnBlur = true, onBlur } = this.props;

    if (validateOnBlur) store.validate([name]);
    else store.clearField(name);

    this.setState({ ...this.state, focus: false });
    onBlur && onBlur(e);
  };

  onKeyPress = e => {
    const { onKeyPress, type } = this.props;
    if (type === "number") {
      const { which } = e;
      const keyValue = String.fromCharCode(which);
      if (!/[\d,.]+/.test(keyValue)) e.preventDefault();
    }
    onKeyPress && onKeyPress();
  };

  render() {
    const {
      store,
      id,
      label,
      inputWidth = "",
      labelWidth = "",
      size = "md",
      formGroupAdd = [],
      inputGroupAdd = [],
      name,
      inputRef,
      inputStyle,
      placeholder,
      onChange,
      onKeyUp,
      onKeyDown,
      type,
      darkBg,
      mobileInline = false,
      inputGroup = false,
      mobileGroup = false,
      animatedLabel = true,
      animatedLabelAbove = false,
      errorPositionAbsolute = false,
      errorOnTop = false,
      tall = this.props.type === "textarea",
      rows = 3,
      additionalInfo = null,
    } = this.props;

    const { focus } = this.state;
    const { stylesEm, onKeyPress } = this;

    const mobileStyled = !mobileInline && isMobile();

    let value = (store && store.data && store.get(name)) || "";

    if (type === "money") {
      value = money(value, { symbol: false });
    }
    if (type === "number") {
      value = value ? Number(value) : "";
    }

    const InputTag = type === "textarea" ? "textarea" : "input";

    const animatedLabelUp = animatedLabel && (focus || value);

    let inputEl =
      type === "blank" ? null : (
        <InputTag
          onFocus={this.onFocus}
          onBlur={this.onBlur}
          placeholder={!animatedLabel || animatedLabelUp ? placeholder : null}
          className={["form-control", inputGroup && inputWidth].filter(Boolean).join(" ")}
          onKeyPress={onKeyPress}
          onKeyUp={onKeyUp}
          onKeyDown={onKeyDown}
          ref={input => {
            this.input = input;
            inputRef && inputRef(input);
          }}
          id={id}
          style={inputStyle}
          name={name}
          onChange={onChange}
          type={type === "money" ? "text" : type}
          value={value}
          aria-label={label}
          rows={type === "textarea" ? rows : null}
        />
      );

    if (type === "money") {
      inputEl = (
        <div className="money position-relative">
          {(animatedLabelUp || !animatedLabel) && <span className="moneySign">€</span>}
          {inputEl}
        </div>
      );
    }

    return (
      <div
        className={[
          "inputText",
          animatedLabelAbove && "animatedLabelAbove",
          darkBg && "darkBg",
          animatedLabel && "placeholderToLabel",
          type === "textarea" && "textarea",
          tall && "tall",
          type === "money" && "money",
          focus && "focus",
        ]
          .filter(Boolean)
          .join(" ")}
      >
        <div
          className={[
            inputGroup && (mobileGroup || !mobileStyled) && "input-group",
            "position-relative",
            `input-group-${size}`,
          ]
            .filter(Boolean)
            .join(" ")}
        >
          {label && (
            <label
              htmlFor={id}
              onClick={() => this.input && this.input.focus()}
              className={[
                "control-label",
                labelWidth,
                animatedLabelUp ? "labelActive" : "labelUnactive",
                animatedLabelUp ? "lActive" : "lUnactive",
              ].join(" ")}
            >
              <span className="labelText">{label || name}</span>
              {!animatedLabelAbove && <span className={["bg", "labelBackground"].join(" ")} />}
              {errorOnTop && store && store.errors && store.errors[name] && (
                <span className="error">
                  <small>{store.errors[name][0]}</small>
                </span>
              )}
            </label>
          )}

          {!inputGroup && (
            <div className={inputWidth}>
              {inputEl}
              {additionalInfo && <div className={stylesEm.additionalInfo}>{additionalInfo}</div>}
            </div>
          )}
          {inputGroup && inputEl}

          {(mobileGroup || !mobileStyled) && inputGroupAdd}

          {formGroupAdd}
        </div>

        {!errorOnTop && store && store.errors && store.errors[name] && (
          <p className={cx(["error", stylesEm.error, errorPositionAbsolute && stylesEm.errorPositionAbsolute])}>
            <small>{store.errors[name][0]}</small>
          </p>
        )}

        {!mobileGroup && mobileStyled && inputGroupAdd}
      </div>
    );
  }

  stylesEm = {
    error: css`
      text-align: left !important;
    `,
    errorPositionAbsolute: css`
      position: absolute;
    `,
    additionalInfo: css`
      position: absolute;
      right: 10px;
      top: 38px;
    `,
  };
}

export default observer(InputText);
